import { useState, useEffect } from 'react';
// mantine
import { Affix, Button, Transition } from '@mantine/core';
// assets
import { ChevronUp } from 'lucide-react';

const scrollToTop = () => {
    const nwContent = document.querySelector('#nw-content');
    nwContent?.scrollTo({ top: 0, behavior: 'smooth' });
};

const ScrollToTopButton = () => {
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = (event: Event) => {
            setScrollY((event.target as HTMLElement).scrollTop);
        };

        const nwContent = document.querySelector('#nw-content');
        nwContent?.addEventListener('scroll', handleScroll);

        return () => {
            nwContent?.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <Affix position={{ bottom: 20, right: 20 }}>
            <Transition mounted={scrollY > 0} transition="slide-up">
                {(transitionStyles) => (
                    <Button
                        leftSection={<ChevronUp />}
                        style={transitionStyles}
                        onClick={scrollToTop}
                    >
                        Scroll to top
                    </Button>
                )}
            </Transition>
        </Affix>
    );
};

export default ScrollToTopButton;
